import script from "./BaseMixin.vue?vue&type=script&lang=js"
export * from "./BaseMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__